import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltip, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sms-log',
  standalone: true,
  imports: [NgFor, NgIf, CommonModule, NgbTooltip, NgbPagination, FormsModule],
  templateUrl: './sms-log.component.html',
  styleUrls: ['./sms-log.component.css']
})
export class SmsLogComponent {

  tableHeaders = ['User ID', 'User Type', 'User Name', 'Mobile No', 'City', 'Zone', 'SMS Category', 'SMS'];

  sms: any = []; // Original data (from API)
  filteredSms: any = []; // Filtered data (from search)
  paginatedData: any = []; // Paginated data for display
  originalSmsData: any = []; // Original data to revert search changes
  searchTerm: string = ''; // Search term

  // Pagination variables
  page = 1;
  pageSize = 10;

  constructor(
    private masterService: MasterInformationService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.GetSmsLogDetails(); // Fetch API data on component load
  }

  clearGrid() {
    this.GetSmsLogDetails();
  }


  // Fetch SMS log details from the API
  GetSmsLogDetails() {
    this.masterService.GetSmsLogDetails(apiEndPoints.GetSmsLogDetails).subscribe({
      next: (response: any) => {
        this.sms = response.body?.details; // Original data
        console.log(this.sms)
        this.filteredSms = [...this.sms]; // Set filtered data to the original
        this.originalSmsData = [...this.sms]; // Store original data for filtering
     
      },
      error: (error) => {
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    });
  }

  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.sms?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // ------------------------------- Search Filter ------------------------------- //
  search(event: any) {
    const searchText = event.target.value.toLowerCase();

    if (!this.originalSmsData) {
      this.originalSmsData = [...this.sms];
    }

    if (searchText) {
      this.sms = this.originalSmsData.filter((item: any) =>
        (item.userName?.toLowerCase().includes(searchText) ||
         item.userType?.toLowerCase().includes(searchText) ||
         item.city?.toLowerCase().includes(searchText) ||
         item.zone?.toLowerCase().includes(searchText) ||
         item.smss?.toLowerCase().includes(searchText) ||
         item.smsCategory?.toLowerCase().includes(searchText))
      );
    } else {
      this.sms = [...this.originalSmsData];
    }
  }

}
